/*
     Title: Cut Plan API
     Description: Cut Plan API
     Author: Iqbal Hossain
     Date: 18-January-2022
     Modified: 18-January-2022
*/

export const CUT_PLAN_API = {
  root: '/api/cut-plan',
  fetch_all: 'api/cut-plan/fetch-all',
  fetch_by_query: `/api/cut-plan/fetch-by-query`,
  fetch_by_id: `/api/cut-plan/fetch-by-id`,
  add: `/api/cut-plan/add`,
  update: `/api/cut-plan/update`,
  delete: `/api/cut-plan/delete`,
  delete_by_range: `/api/cut-plan/delete-range`
};
